export default {
	card: 'Card',
	us_bank_account: 'US Bank',
	sepa_debit: 'SEPA',
	acss_debit: 'ACSS'
};
